import { ApiError, ValidationError } from './Errors';

export type Token = {
  id_token: string;
  access_token: string;
  expires_in: number;
  token_type: string;
  refresh_token: string;
  scope: string;
};

export type ApiConfig = {
  getBaseUrl: () => string | Promise<string>;
  getSocketUrl: () => string;
  getUserId: () => Promise<string | null | undefined>;
  getAccessToken: () => Promise<string | null | undefined>;
  refreshToken: () => Promise<string>;
  waitForRefreshToken: (url: string) => Promise<Token | void>;
  getToken: () => Promise<Token | null | undefined>;
  getRequestHeaders?: () =>
    | Record<string, string>
    | Promise<Record<string, string>>;
  onApiError?: (
    error: Partial<ApiError | ValidationError>,
  ) => void | Promise<void>;
};

let config: ApiConfig;

export const init = (conf: ApiConfig) => {
  config = conf;
};

const Config = new Proxy<ApiConfig>({} as ApiConfig, {
  get(_, property: keyof ApiConfig) {
    if (!config) {
      throw new Error('Config is not initialized. Call `init` first.');
    }

    const value = config[property];
    if (typeof value !== 'function') {
      throw new Error(
        `Property '${String(property)}' is not a function or does not exist.`,
      );
    }

    return value.bind(config);
  },
});

export default Config;
